"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _excluded = ["name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** This creates a new reducer.
 * @param {{name: string, ...slices}} [reducerData] The reducer object.
 * @returns {function} The new reducer.
 */
var create = function create(_ref) {
  var name = _ref.name,
      slices = _objectWithoutProperties(_ref, _excluded);

  var actionHandlers = {};
  Object.keys(slices).forEach(function (slice) {
    actionHandlers["".concat(name, "_set_").concat(slice)] = function (state, action) {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, slice, action.content));
    };
  });
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var handler = actionHandlers[action.type];
    return handler ? handler(state, action) : state;
  };
};
/** This updates the state of a key within a reducer.
 * @param {{name: string}} [reducerData] The reducer object.
 * @param {string} [slice] The key to be updated.
 * @returns {Object} The dispatch request.
 */


var setSlice = function setSlice(_ref2, slice, content) {
  var name = _ref2.name;
  return {
    type: "".concat(name, "_set_").concat(slice),
    content: content
  };
};
/** This gets a desired key from a redux state object.
 * @param {{name: string}} [reducerData] The reducer object.
 * @param {Object} [state] The redux state.
 * @returns {Object} An object containing the reducer's keys and values.
 */


var getSlice = function getSlice(_ref3, slice, state) {
  var name = _ref3.name;
  var reducerState = state[name] || {};
  return reducerState[slice];
};

var _default = {
  create: create,
  setSlice: setSlice,
  getSlice: getSlice
};
exports["default"] = _default;